<template>
    <!-- hover:shadow-xl -->
    <div
        class="w-full mb-3 bg-white  transition-all h-16 rounded-md px-4 flex flex-row justify-between items-center border "
    >
        <div
            class=" file-name-box flex flex-row justify-start items-center"
            style="width: calc(100% - 100px)"
        >
            <CouponIcon :fillClass="'fill-primary'"/>

            <div class="ml-4 " style="width: calc(100% - 40px)">
                <h3
                    class=" text-black whitespace-nowrap overflow-ellipsis overflow-hidden w-full "
                >
                    Gutscheincode: {{ coupon.code }}
                </h3>

                <p class="text-s text-grey -mt-1">Wert: {{ coupon.value }}€</p>
            </div>
        </div>
        <div class="flex flex-row items-center justify-end">
            <icon-container
                class="hover:bg-white-dark transition-all bg-transparent"
                icon="CopyIcon"
                :iconSize="'5'"
                iconFill="fill-grey"
                @click="copyToClipboard(coupon.code)"
            />
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import IconContainer from "../../components/helper/IconContainer.vue";
import { HELPER_TYPES, MEDIA_TYPES, STORE_TYPES } from "../../store/types";
import { resolveFileIconName } from "../../common/fileTypeHelper";
export default defineComponent({
    name: "DocumentsContainer",
    components: { IconContainer },
    emits: [],
    props: { coupon: { required: true } },
    setup(props) {
        const store = useStore();
        const state = reactive({});

        function DOWNLOAD_MEDIA() {
            store.dispatch(
                `${STORE_TYPES.MEDIA}/${MEDIA_TYPES.DOWNLOAD_MEDIA}`,
                { media: props.media }
            );
        }

        function OPEN_MEDIA_IN_NEW_TAB() {
            store.dispatch(
                `${STORE_TYPES.MEDIA}/${MEDIA_TYPES.OPEN_MEDIA_IN_NEW_TAB}`,
                { media: props.media }
            );
        }
        

        function copyToClipboard(coupon) {
            navigator.clipboard.writeText(coupon);
            // alert("Copied the text: " + coupon);
            store.commit(`${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_TOAST_MESSAGE}`, "Ihr Gutscheincode wurde in der Zwischenablage hinterlegt.");
        }
        /**
         *  Computed
         */
        const fileIcon = computed(() => {
            return resolveFileIconName(props.media.name);
        });

        return { state, fileIcon, OPEN_MEDIA_IN_NEW_TAB, DOWNLOAD_MEDIA,copyToClipboard };
    },
});
</script>
